import { TFunction } from 'i18next';

const operationType = (type: string, t: TFunction) => {
  switch (type) {
    case 'INTERBANK':
      return <span>{t('Interbank')}</span>;
    case 'OWN':
      return <span>{t('Between own accounts')}</span>;
    case 'INTERNAL':
      return <span>{t('Internal')}</span>;
    default:
      break;
  }
};

export default operationType;
